import React from "react";
import { connect } from "react-redux";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MaterialDataTable from "material-table/Table.js";
import {
    crudActions,
    confirmActions,
    modalActions,
    loaderActions,
} from "../../../_actions";
import { fileService } from "../../../_services/file.service";
import { PermissionHelper } from "_helpers";


const title = "Download Resume";
class DownloadList extends React.PureComponent {

    componentDidUpdate() {
        if (this.props.confirm.confirm) {
            if (this.props.confirm.data.length) {
                const ids = this.props.confirm.data.map((value) => value.id);
                this.props.deleteAllCrud("form", "resume-Download/delete_all", {
                    ids: JSON.stringify(ids),
                });
            } else {
                if (this.props.confirm.data.id) {
                    this.deleteData(this.props.confirm.data.id);
                }
            }
            this.props.clearConfirm();
        }
    }
  
    export = () => {
        fileService._download("reports/jobseekerreport");
    };
    render() {
        const columns = [
            {
                title: "Recruiter",
                field: "recruiter.name",
            },
            {
                title: "Job Seeker",
                field: "jobseeker.first_name",
            },
            {
                title: "Created Date",
                field: "created_at",
                defaultSort: "desc",
            },
        ];

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <MaterialDataTable
                        title={title}
                        columns={columns}
                        url="resume-download"
                        selection={true}
                        grouping={false}
                        defaultExpanded={true}
                        refresh={true}
                        serverSide={true}
                        search={true}
                        sorting={true}
                        filtering={true}
                        export={
                            PermissionHelper.checkPermission(
                                "export_consultant_payout_reports"
                            )
                                ? this.export
                                : false
                        }
                    />
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const { authentication, confirm } = state;
    const { user } = authentication;
    return { user, confirm };
};

const actionCreators = {
    getRole: crudActions._get,
    deleteCrud: crudActions._delete,
    deleteAllCrud: crudActions._deleteAll,
    showConfirm: confirmActions.show,
    clearConfirm: confirmActions.clear,
    openModal: modalActions.open,
    showLoader: loaderActions.show,
    hideLoader: loaderActions.hide,
    activateConsultant: crudActions._create,
    deactivateConsultant: crudActions._create,
};

export default connect(
    mapStateToProps,
    actionCreators
)(DownloadList);